<template>
  <div class="userInfoContent">
    <ul class="userInfo">
      <li class="base">
        <div class="back flex-box flex-hv-c" @click="back">
          <i class="iconfont icon-houtui"></i>
        </div>
        <div class="logOut flex-box flex-hv-c" @click="logOut">
          <i class="iconfont icon-exit"></i>
        </div>
        <div class="msg">
          <div class="flex-box flex-hv-c mb">
            <i class="iconfont icon-yonghu"></i>
            <span class="realname">{{userInfo.nickname || userInfo.realname}}-{{userInfo.id}}</span>
          </div>
        </div>
      </li>
      <li class="bb">
        <span class="key">
          <i class="iconfont icon-shouji"></i>手机号：
        </span>
        <span>{{userInfo.mobileNum}}</span>
      </li>
      <li class="bb" v-if="userInfo.memberId">
        <span class="key">
          <i class="iconfont icon-daili1"></i>代理ID：
        </span>
        <span>{{userInfo.memberId}}</span>
      </li>
      <li class="bb" @click="changeInfo('realname')">
        <span class="key">
          <i class="iconfont icon-yonghu"></i>真实姓名：
        </span>
        <span>{{userInfo.realname}}</span>
        <i class="iconfont icon-more"></i>
      </li>
      <li class="bb" @click="changeInfo('idcard')">
        <span class="key">
          <i class="iconfont icon-sfz"></i>身份证：
        </span>
        <span>{{userInfo.creditId}}</span>
        <i class="iconfont icon-more"></i>
      </li>
      <li class="bb" @click="changeInfo('alipay')">
        <span class="key">
          <i class="iconfont icon-pay"></i>支付宝：
        </span>
        <span>{{userInfo.alipayAccount}}</span>
        <i class="iconfont icon-more"></i>
      </li>
      <li class="bb" @click="changeInfo('bankcard')">
        <span class="key">
          <i class="iconfont icon-sfz"></i>银行卡：
        </span>
        <span>{{userInfo.cardNum}}</span>
        <i class="iconfont icon-more"></i>
      </li>
      <li class="bb" @click="highSet()">
        <span class="key"><i class="iconfont icon-shezhi"></i>高级设置</span>
        <i class="iconfont icon-more"></i>
      </li>
      <li class="bb">
        <span class="key">
          <i class="iconfont icon-edit1"></i>注册时间：
        </span>
        <span>{{createTime}}</span>
      </li>
      <li class="bb" v-show="partnerCompnay">
        <span class="key">
          <i class="iconfont icon-attachment"></i>推广公司：
        </span>
        <span>{{partnerCompnay}}</span>
      </li>
    </ul>
  </div>
</template>
<!--javascript-->
<script>
export default {
  name: 'userInfo',
  data: function () {
    return {

    }
  },
  methods: {
    highSet(){
      this.$toast("暂停开放，请耐心等待！");
    },
    changeInfo(type){
      if(type == 'realname'){
        this.$router.push('/userInfo/updateName')
      } else if(type == 'idcard'){
        this.$router.push('/userInfo/updateIdentityNum')
      } else if(type == 'alipay'){
        this.$router.push('/userInfo/updateAliAccount')
      } else if(type == 'bankcard'){
        this.$router.push('/userInfo/updateCard')
      }
    },
    /**刷新用户信息**/
    resUserInfo() {
      var that = this
      that.$store.dispatch('getUserMsg')//初始请求用户信息 得到数据 存放store中
    },
    back() {
      var that = this
      that.$router.push('/home')
    },
    logOut() {
      var that = this

      this.$messagebox.confirm('您将退出登录~', '提示').then(function () {
        localStorage.clear()
        if (that.$common.common.browser.versions.weixin) {
          WeixinJSBridge.call('closeWindow');
        }
        else {
          localStorage.clear()
          that.$router.push('/login')
        }

      })
    }
  },
  computed: {
    userInfo: function () { 
      return this.$store.state.userMsg.userMsg
    },
    createTime: function () {
      return this.$common.common.formatDate(this.$store.state.userMsg.userMsg.createTime)
    },
    partnerCompnay() {
      return this.$store.state.userMsg.partnerCompnay
    },
  },
  mounted: function () {
  },
  created: function () {
    this.resUserInfo()
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
.userInfoContent {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  .userInfo {
    li:not(:first-child) {
      padding: 0 10px;
      display: flex;
      align-items: center;
      position: relative;
      height: 1rem;
      .fa-refresh {
        color: #fff;
      }
      .icon-more{
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        color: rgba(0,0,0,.4);
      }
    }
    .base {
      background-size: 100%;
      background-position: center center;
      background-repeat: no-repeat;
      height: 3rem;
      position: relative;
      z-index: 1;
      color: #fff;
      background:linear-gradient(to right, #707be4, #5458b7);
      .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 1rem;
        height: 1rem;
      }
      .logOut {
        position: absolute;
        top: 0;
        right: 0;
        width: 1rem;
        height: 0.9rem;
      }
      .icon-houtui:before {
        font-size: 0.7rem;
      }
      .icon-houtui,
      .icon-exit {
        color: #fff;
      }
      .msg {
        position: absolute;
        bottom: 0.5rem;
        width: 100%;
        color: #fff;
        .icon-yonghu:before{
          color:#fff;
        }
      }
      .realname {
        font-size: 24px;
      }
    }
    .key {
      display: flex;
      align-items: center;
      width: calc(1.7rem);
    }
    .baseTxt {
      width: 100%;
      height: 100%;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userInfo/index.vue